var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSorter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#F4F4F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7559 19.1271C12.3572 19.5876 11.6428 19.5876 11.2441 19.1271L8.23682 15.6547C7.67594 15.007 8.136 14 8.99275 14L15.0073 14C15.864 14 16.3241 15.007 15.7632 15.6547L12.7559 19.1271Z",
    fill: "#929A92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2441 4.87287C11.6428 4.41241 12.3572 4.41241 12.7559 4.87287L15.7632 8.34535C16.3241 8.99299 15.864 10 15.0073 10H8.99275C8.136 10 7.67594 8.99299 8.23682 8.34535L11.2441 4.87287Z",
    fill: "#30556B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSorter);
export default __webpack_public_path__ + "static/media/sorter.68e0d346016e760062074e860b6b5dcf.svg";
export { ForwardRef as ReactComponent };